import { render } from "./TheFooter.vue?vue&type=template&id=729ab644"
const script = {}

import exportComponent from "D:\\Работа\\vue3\\_gorcenter\\lk5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__